import { useMemo } from "react";
import { Skeleton, Flex, Tag, Typography, Tabs, Button } from "antd";
import ObjectFieldsTable from "@/components/tables/ObjectFieldsTable";
import styles from "./right-drawer.module.css";
import routes from "@/routes";
import ExternalLinkIcon from "@/icons/ExternalLinkIcon";

const { Title } = Typography;

const ObjectPanel = ({
  currentObject,
  isLoading,
  activeTabKey,
  setActiveTabKey,
}) => {
  const { definition, object } = currentObject || {};
  const stableObject = useMemo(() => object, [object]); //чтобы не было перерендера

  const groupsFields = useMemo(() => {
    if (!definition?.groups) return [];

    return [...definition.groups]
      .filter((g) => g.fields?.length)
      .sort((a, b) => a.idx - b.idx);
  }, [definition?.groups]);

  return (
    <Flex vertical gap={20} className={styles.object_panel}>
      {isLoading ? (
        <Skeleton active size="large" />
      ) : (
        <Flex vertical className={styles.object_panel_body}>
          <Flex justify="space-between" gap={8}>
            <Flex gap={10} align="flex-start">
              <Title level={2} className={styles.title}>
                {object?.name}
              </Title>
              <Tag color="blue" className={styles.tag}>
                {object?.unit?.name}
              </Tag>
            </Flex>
            <Button
              icon={<ExternalLinkIcon />}
              disabled={!definition?.uuid || !object?.uuid}
              onClick={() => {
                window.open(
                  routes.objectDetail(definition.uuid, object.uuid),
                  "_blank",
                );
              }}
              size="small"
              style={{ border: "none" }}
              type="text"
            />
          </Flex>
          <div className={styles.content}>
            {definition?.type === "object" && (
              <div className={styles.definition_info}>
                <Title level={5} className={styles.definition_title}>
                  {definition?.name}
                </Title>
                {definition?.description && (
                  <div className={styles.definition_description}>
                    <div>{definition.description}</div>
                  </div>
                )}
              </div>
            )}
            <Tabs activeKey={activeTabKey} onChange={setActiveTabKey}>
              {groupsFields.map((group) => (
                <Tabs.TabPane tab={group.name} key={group.uuid}>
                  <ObjectFieldsTable
                    fields={group.fields}
                    object={stableObject}
                    color={definition?.color}
                  />
                </Tabs.TabPane>
              ))}
            </Tabs>
          </div>
        </Flex>
      )}
    </Flex>
  );
};

export default ObjectPanel;
